import { SVGProps } from "react";

const STIAdobe = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Adobe" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} fill="#ed2224" rx="15%" /><path fill="#fff" d="M296,120h114v272zm-80,0h-114v272zm39,99-48,118h52l23,55h46z" /></svg>;

export { STIAdobe };